import { useMemo } from 'react';
import { useLang } from '../../../../../hooks/use-lang';
import { DashboardCardDataType } from '../../../../../store/api/dashboard-api';
import { DashboardCardProps } from '../dashboard-components/dashboard-cards/dashboard-card/dashboard-card';
import { useDashboardStore } from '../../../../../store/use-dashboard-store';

type PossibleKeys = keyof Omit<DashboardCardDataType, 'waiter'>;

type DataType = {
  series: { name: PossibleKeys; data: number[] }[];
  categories: string[];
};

const recordCards: Record<PossibleKeys, string> = {
  scans: 'Всего сканирований',
  devices: 'Уникальных устройств',
  tasks: 'Задач',
  orders: 'Заказов',
  reviews: 'Отзывов',
};

export const useDashboardQrCards = (): DashboardCardProps[] => {
  const { t } = useLang();
  const { list } = useDashboardStore();
  const series = (list?.qr_stats as DataType)?.series || [];

  const result: DashboardCardProps[] = useMemo(() => {
    if (!series) return [];

    return series.map(({ data, name }) => {
      const assertedKey = name as PossibleKeys;

      const title = t(recordCards[assertedKey]);
      const value = String(data.reduce((sum, value) => sum + value, 0));

      return {
        title,
        content: value || '0',
      };
    });
  }, [series, t]);

  return result;
};
